module.exports = __webpack_public_path__ + "static/media/Inner Pages - Mobile 320x100.7b5d72d5.png";